module.exports = __webpack_public_path__ + "img/rosario_fall.3a63b3e3.svg";